<template>
  <div>
    <table
      class="table table-sm table-bordered data-table"
      :class="{selectable: variant === 'footage'}"
    >
      <thead v-if="variant === 'maintenance'">
        <tr>
          <th colspan="2">
            <icon-header icon="wrench">Maintenance Data</icon-header>
          </th>
        </tr>
      </thead>
      <thead v-else-if="variant === 'movement' || variant === 'footage'">
        <tr>
          <th colspan="2">
            <icon-header icon="exchange">Movement Data
              <help-tip
                class="ml-1"
                v-if="isMaintenance"
                title="Below shows all recorded movements that took place while this maintenance request was active."
              />
            </icon-header>
          </th>
        </tr>
      </thead>
      <thead v-else-if="variant === 'battery'">
        <tr>
          <th colspan="2">
            <icon-header icon="battery-three-quarters">Battery Data</icon-header>
          </th>
        </tr>
      </thead>
      <tbody v-if="visibleResults && visibleResults.length">
        <tr
          v-for="result in visibleResults"
          :key="result._id"
          @click="rowClicked(result._id)"
          :class="{selected: result._id === selected}"
        >
          <td>
            <span v-if="variant === 'maintenance'">
              <i
                class="fas fa-ban mr-1 o70"
                v-b-tooltip.hover
                title="This request was cancelled prior to its completion."
                v-if="result.active === false"
              ></i>
              <span v-max-ellipsis="200">
                <strong>
                  <b-link
                    class="data-link"
                    @click="$_openRequestModal(result._id)"
                  >{{result.reason}}</b-link>
                </strong>
              </span>
            </span>
            <span v-max-ellipsis="220" v-else-if="variant === 'movement' || variant === 'footage'">
              <strong>
                {{$_areaName(result.previousArea)}}
                <i class="far fa-long-arrow-right mx-1"></i>
                {{$_areaName(result.area)}}
              </strong>
            </span>
            <span v-else-if="variant === 'battery'">
              <battery-badge :level="result.level" />
            </span>
          </td>
          <td>
            <span>{{result.createdAt | toDateTimeString}}</span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr class="no-results">
          <td colspan="2">
            <no-results :background="false"/>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="result-disclaimer"
      v-if="isLimited === true"
    >Limited to up to the five most recent results.</div>
    <result-pagination
      v-show="variant !== 'battery'"
      v-if="filtered"
      v-model="visibleResults"
      :small="true"
      :custom-page-length="pageLength"
      :filtered="filtered"
      :custom-hidden="isLimited"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      visibleResults: null
    };
  },
  computed: {
    selected: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.value;
      }
    }
  },
  methods: {
    rowClicked(id) {
      if (this.variant === "footage") {
        this.selected = id;
      }
    }
  },
  props: {
    value: {
      type: String
    },
    filtered: {
      type: Array,
      required: true
    },
    isLimited: {
      type: Boolean,
      default: false
    },
    pageLength: {
      type: Number,
      default: 5
    },
    variant: {
      type: String,
      required: true,
      validator: value => ["movement", "maintenance", "footage", 'battery'].includes(value)
    },
    isMaintenance: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.data-table {
  font-size: 0.75rem;
  margin-bottom: 0;

  thead {
    background-color: #ebebeb;

    th {
      border-bottom: 0px solid #dee2e6 !important;
    }
  }

  td {
    border-right: none !important;
    border-left: none !important;
  }

  td:nth-child(2) {
    text-align: right;
  }

  &.selectable {
    tbody tr:not(.no-results) {
      cursor: pointer;
    }

    tbody tr:hover:not(.no-results) {
      background-color: whitesmoke;
    }

    tbody tr.selected, tbody tr.selected:hover{
      background-color: #ebebeb !important;
      cursor: default;
    }
  }
}

.result-disclaimer {
  font-size: 0.75rem;
  font-weight: 400;
  opacity: 0.7;
}
</style>